import Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class ZendeskHandoffMessageRecord extends BaseMessageRecord({
  type: "helpdesk_handoff_recipe",
  captureAction: Immutable.Map({
    type: "capture",
    captureLead: "What's your email?",
    captureKey: "email",
    captureLocked: false,
    captureType: "email"
  }),
  confirmationMessage: Immutable.Map({
    body: "I've sent your question to our team. Can I help with anything else?",
    type: "text"
  }),
  helpdeskAction: Immutable.Map({
    type: "zendesk_handoff",
    tags: "ada",
    inlineChatterInfo: false,
    uniqueSubject: false,
    inlineTranscript: false,
    subject: ""
  })
}) {
  static getInvalidFields = () => Immutable.List();
}

export default ZendeskHandoffMessageRecord;
